import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import Marquee from 'react-fast-marquee';
import { ArrowRight, Truck, RefreshCw, Shield, Star } from 'lucide-react';
import { Button } from '../components/ui/button';
import ProductCard from '../components/ProductCard';
import { card as optCard, hero as optHero } from '../lib/imageUrl';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Doe Wiz Apparel Brand Images
const BRAND_IMAGES = {
  logo_banner: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/28vifbmr_1500x500.jpeg",
  tracksuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/hwvrbt4z_F0s_jvqXsAsZmEI.jpeg",
  camo_jacket: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/lktwp0ar_F1prB3YWYAAicQG.jpeg",
  brown_cap: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/gdaa53gj_F4T3VBgWcAYh8em.jpeg",
  cream_sweatsuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/vih8z7ev_F6ef3D6XEAAC-ha.jpeg",
  cream_crewneck: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/e7e59o7c_F6U2vwTXkAE8-Ku.jpeg",
  burgundy_sweatsuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/1uih0tby_F7IZ-eVXsAAGyGQ.jpeg",
  blue_womens_set: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/vpxd796w_F10U2SZXoAAkDOi.jpeg",
  checkered_hoodie: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/9hw70r77_F17kPz5WYAAPyaz.jpeg",
  pink_bomber: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/vuiunv22_F19SbREWIAI_j-e.jpeg",
  // Batch 3
  orange_tee: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/0rpxou76_F041maPXsAcpK3d.jpeg",
  burgundy_back: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/k5jslqi6_F58IdSlXUAAhtKw.jpeg",
  yellow_cap: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/eo42hm6g_Fae3H0nWIAA7nBL.jpeg",
  black_mascot_tee: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/75qvnvaw_FFXZVGPXMAI6FTn.jpeg",
  white_womens_tracksuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/k92glpfn_FGAsPoSWUAQXPpA.jpeg",
  // Batch 4
  purple_hoodie: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/lq014zzd_FgqAVLLWIAAL2qu.jpeg",
  orange_hoodie: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/86cywenv_Fh1AJn8XoAA6myG.jpeg",
  autism_tee: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/ze7r6yw5_FK2sqFGXEAE9_f3.jpeg",
  black_gold_tee: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/g1ckplbr_FK6xY_fXIAMIFWg.jpeg",
  white_pink_sweatsuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/uo35kb7f_FK22r67XwAA8fu9.jpeg",
  // Batch 5
  denim_cap: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/4bj6rgf5_FLAcfcqXsAQMrZW.jpeg",
  burgundy_vneck: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/g9tdai94_FLXl2hSXwAgyPjk.jpeg",
  black_red_tracksuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/j2qwila6_Fn0iMleWIAIskX2.jpeg",
  blue_yellow_tracksuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/u802muqj_FnLaYVzWAAgPb2o.jpeg",
  blue_yellow_promo: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/sryhg14c_FnVjcwzWQAAAYYO.jpeg",
  // Batch 6
  orange_hoodie_flat: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/7kh94637_Fp_c9j_X0AATa6K.jpeg",
  orange_sweatsuit_model: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/le51d62h_Fp_c9kiWYA4VNAB.jpeg",
  varsity_jacket_set: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/r8igui2h_Fp-kEEnX0AY2tLL.jpeg",
  pink_cap_holiday: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/el3w5hhe_FpagStmWcAIQiv7.jpeg",
  red_hoodie_promo: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/qmliwvq6_FqBXiwBXwAICh5F.jpeg",
  // Batch 7
  green_varsity: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/t3tk62z2_Fr2Vfe9WcAAe4ID.jpeg",
  colorful_hoodie: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/1nmbxge1_FrMa7wRXsAEb9f9.jpeg",
  white_varsity: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/fapul29o_FtdlVvUXsAAdFOy.jpeg",
  white_tracksuit_model: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/r07ti6dz_FuBev1kXsAENyIL.jpeg",
  green_mascot_hoodie: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/rftz55n2_FuR6wyzX0AIad6J.jpeg",
  // Batch 8
  black_glitter_tee: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/ck2ochzc_FVT3R2QWAAED--p.jpeg",
  cream_tracksuit_womens: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/igmiyte8_FXd9JiRWQAAgzc3.jpeg",
  camo_collection: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/w7da449z_FxDuV_jWAAAz2GA.jpeg",
  royal_blue_sweatsuit: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/nsc252rx_FxFmeBvX0AAGMtW.jpeg",
  womens_camo_set: "https://customer-assets.emergentagent.com/job_clothing-marketplace-14/artifacts/rssgy9ru_FxOHPuUXsAMDHuv.jpeg",
  // Batch 9
  red_tracksuit_stage: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/9u5mfhuy_FzAM2HvWACA0rl5.jpeg",
  event_collage: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/ain1zz8w_FzkNkJ-WIAgP-n-.jpeg",
  green_cream_cap: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/ajhrapdq_G1zybnoWEAAvNtf.jpeg",
  brand_logo_bw: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/6kxkfu1s_G3VBXv3XAAMlNbP.jpeg",
  red_crewneck_promo: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/d89gbibh_GBveE85WcAAesue.jpeg",
  // Batch 10
  january_promo: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/46egkc50_GhVrUeYWsAAeTT1.jpeg",
  march_blue_yellow_tracksuit: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/tln2yj0r_GIeICgUXEAA0JVF.jpeg",
  white_polo_shorts: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/c0arlfwl_GLQVYA2X0AAN3MV.jpeg",
  orange_cargo_shorts: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/4nawyyby_GLQVYA3XgAAUBc0.jpeg",
  polo_orange_shorts_set: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/ilhs2l2l_GLQVYAzWAAIQUPQ.jpeg",
  // Batch 11
  white_gold_tee: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/csujc2hl_GnqUHQeWUAAnWej.jpeg",
  white_varsity_tee_flat: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/adeqpysz_GnqUHQXXIAAUbX5.jpeg",
  white_varsity_tee_couch: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/69cqd2aw_GnqUHQYWwAAMv91.jpeg",
  pink_velvet_trucker: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/jrk0isjn_GRat7_cb0AM8ISp.jpeg",
  black_suede_trucker: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/6mrjlkaf_GRDLVj0WEAASMCr.jpeg",
  // Batch 12
  striped_vneck_tee_1: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/qqhmq4gl_GrXJgTJW0AA3qtH.jpeg",
  striped_vneck_tee_2: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/9v1pnvfk_GrXJgTOXUAALN40.jpeg",
  pink_satin_bomber: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/04j8jh55_F19SbREWIAI_j-e.jpeg",
  orange_5panel_cap: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/16tocprm_HA6jRDJbsAMoc9Y.jpeg",
  orange_mascot_tee: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/ypggrq0n_HA6jRDYbsAIf-YX.jpeg",
  store_display_hats_perfumes: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/2y9y9o3z_HAfL_XRWIAIrx-M.jpeg",
  // Batch 13 - Winter Collection
  red_puffer_jacket: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/vai0ullr_HAgfUb8WoAApx3k.jpeg",
  yellow_puffer_jacket: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/v3m0n382_HAhpVfgXgAA3fqh.jpeg",
  plaid_flannel_shirt: "https://customer-assets.emergentagent.com/job_b74253f6-0045-47f8-b035-a9fa386c3b43/artifacts/xunfwjyd_HAMBFx2XkAAQ7nv.jpeg",
};

// Hero slides — mixed images + videos (2026-02 refresh v3).
// - Slides cycle automatically (4s for stills, 7s for looped video clips)
// - The FINAL slide is video #1 which plays in full (~17s) and advances on `ended`
//   so every cycle closes with a proper Paris Fashion Week moment.
const HERO_SLIDES = [
  // Yellow fit couple (TOGETHER)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/gwatdtwx_1000155950.jpg', persona: 'together' },
  // Yellow hoodie model (FEMALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/a8d6tajg_1000155952.jpg', persona: 'female' },
  // Runway patchwork hoodie (MALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/c55olpqu_1F270322-C9DB-47D8-8349-4E459338BFC1.jpg', persona: 'male' },
  // Teal tie-dye (FEMALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/3h6wnmgd_IMG_2301.JPG', persona: 'female' },
  // His & Hers pink varsity (TOGETHER)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/3zoo53i4_IMG_2752.jpg', persona: 'together' },
  // PFW short clip
  { type: 'video', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/mec9dbi4_1000155946.mp4', persona: 'fashion-week', loop: true },
  // Blue velvet cap (MALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/anovrzun_IMG_2963.jpg', persona: 'male' },
  // PFW short clip
  { type: 'video', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/w6wny538_1000155947.mp4', persona: 'fashion-week', loop: true },
  // His & Hers back-to-back (TOGETHER)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/ed9v4z4i_IMG_2753.jpg', persona: 'together' },
  // Blue/yellow tracksuit (MALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/88uk07ra_IMG_2964.jpg', persona: 'male' },
  // PFW short clip
  { type: 'video', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/uly2bxbb_1000155948.mp4', persona: 'fashion-week', loop: true },
  // Graffiti hoodie (MALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/5pxcih3l_IMG_2285.PNG', persona: 'male' },
  // 🆕 Kids Drop short clip (KIDS) — bumped into the rotation 2026-05
  { type: 'video', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/rfy6uaok_export_1681145503914.MOV', persona: 'kids', loop: true },
  // Afro splatter hoodie (MALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/zbfkdwm1_IMG_2965.jpg', persona: 'male' },
  // Splatter hoodie sofa (MALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/s10b0ssp_IMG_2966.jpg', persona: 'male' },
  // Runway black tee (MALE)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/pk2hwnk8_IMG_3002.JPG', persona: 'male' },
  // Fashion Week still (editorial poster)
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/42ga4cu4_1000155929.jpg', persona: 'fashion-week-still' },
  // 🎬 CLOSING — Video #1 plays in FULL before cycle restarts
  { type: 'video', src: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/uwryxtva_1000155930.mp4', persona: 'fashion-week', loop: false, playFull: true },
];

// Back-compat
const HERO_IMAGES = HERO_SLIDES.map((s) => s.src);

const categories = [
  // Women — yellow solo hoodie model (user preference)
  { name: 'Women', color: 'bg-[#FAD4D4]', image: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/a8d6tajg_1000155952.jpg', size: 'large' },
  { name: 'Men', color: 'bg-[#D4E2FA]', image: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/anovrzun_IMG_2963.jpg', size: 'medium' },
  { name: 'Kids', color: 'bg-[#FDF0D5]', image: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/tnid4hgs_IMG_1533.jpeg', size: 'medium', subcategories: ['boys', 'girls', 'babies'] },
  // Hats — Royal Blue Velvet Trucker Cap (swapped from Skulls & Roses to avoid visual duplication with the Featured grid)
  { name: 'Hats', color: 'bg-[#D5FDD8]', image: 'https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/aufu4oi5_IMG_2270.PNG', size: 'small' },
  { name: 'Accessories', color: 'bg-[#F0D5FD]', image: BRAND_IMAGES.store_display_hats_perfumes, size: 'small' },
];

export default function HomePage() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [promoProducts, setPromoProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentHeroIndex, setCurrentHeroIndex] = useState(0);
  const [direction, setDirection] = useState(1); // 1 = forward, -1 = backward

  // 🔥 STRIKING URBAN TRANSITIONS v2 — dramatic, cinematic, zero-subtlety
  // Every slide triggers a full-frame flash + chromatic-aberration shadow overlay for punch.
  const transitionVariants = [
    // 0 — SHATTER SLICE (hard diagonal tear with heavy motion + slight rotate)
    {
      name: 'shatter-slice',
      initial: {
        clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
        scale: 1.25,
        rotate: -5,
        filter: 'saturate(1.6) contrast(1.3)',
      },
      animate: {
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
        scale: 1,
        rotate: 0,
        filter: 'saturate(1) contrast(1)',
      },
      exit: {
        clipPath: 'polygon(100% 0, 100% 0, 100% 100%, 100% 100%)',
        scale: 0.88,
        rotate: 6,
        filter: 'saturate(0.4) contrast(1.5) brightness(0.6)',
      },
    },
    // 1 — HEAVY GLITCH (extreme RGB split, violent shake, hue flip)
    {
      name: 'heavy-glitch',
      initial: {
        opacity: 0,
        x: -40,
        skewX: -6,
        scale: 1.1,
        filter: 'hue-rotate(80deg) saturate(2) contrast(1.5) drop-shadow(-6px 0 #ff0055) drop-shadow(6px 0 #00e5ff)',
      },
      animate: {
        opacity: 1,
        x: 0,
        skewX: 0,
        scale: 1,
        filter: 'hue-rotate(0deg) saturate(1) contrast(1) drop-shadow(0 0 transparent)',
      },
      exit: {
        opacity: 0,
        x: 40,
        skewX: 6,
        scale: 0.95,
        filter: 'hue-rotate(-80deg) saturate(2) contrast(1.5) drop-shadow(6px 0 #ff0055) drop-shadow(-6px 0 #00e5ff)',
      },
    },
    // 2 — CAMERA SHUTTER (iris close/open from edges)
    {
      name: 'shutter',
      initial: { clipPath: 'inset(50% 50% 50% 50%)', scale: 1.3, filter: 'brightness(1.6)' },
      animate: { clipPath: 'inset(0% 0% 0% 0%)', scale: 1, filter: 'brightness(1)' },
      exit: { clipPath: 'inset(0% 50% 0% 50%)', scale: 0.9, filter: 'brightness(0.3)' },
    },
    // 3 — EQUALIZER STRIPES (5 vertical bars rising aggressively)
    {
      name: 'equalizer',
      initial: {
        clipPath:
          'polygon(0% 100%, 20% 100%, 20% 100%, 40% 100%, 40% 100%, 60% 100%, 60% 100%, 80% 100%, 80% 100%, 100% 100%, 100% 100%, 0% 100%)',
        filter: 'saturate(1.8) brightness(1.2)',
      },
      animate: {
        clipPath:
          'polygon(0% 0%, 20% 0%, 20% 0%, 40% 0%, 40% 0%, 60% 0%, 60% 0%, 80% 0%, 80% 0%, 100% 0%, 100% 100%, 0% 100%)',
        filter: 'saturate(1) brightness(1)',
      },
      exit: { clipPath: 'inset(0% 0% 100% 0%)', filter: 'saturate(0.3) brightness(0.3)' },
    },
    // 4 — 3D FLIP BURST (perspective rotate + motion blur)
    {
      name: '3d-flip',
      initial: {
        opacity: 0,
        rotateY: -90,
        scale: 1.2,
        filter: 'blur(14px) saturate(1.6)',
        transformPerspective: 1200,
      },
      animate: {
        opacity: 1,
        rotateY: 0,
        scale: 1,
        filter: 'blur(0px) saturate(1)',
      },
      exit: {
        opacity: 0,
        rotateY: 90,
        scale: 0.8,
        filter: 'blur(14px) saturate(0.5) brightness(0.4)',
      },
    },
    // 5 — KICK SNAP (fast pull-in with rotational overshoot + RGB split)
    {
      name: 'kick-snap',
      initial: {
        opacity: 0,
        scale: 1.8,
        rotate: -12,
        filter: 'blur(20px) saturate(1.8) contrast(1.4) drop-shadow(-8px 0 #ff2e5c) drop-shadow(8px 0 #00e5ff)',
      },
      animate: { opacity: 1, scale: 1, rotate: 0, filter: 'blur(0px) saturate(1) contrast(1)' },
      exit: {
        opacity: 0,
        scale: 0.6,
        rotate: 12,
        filter: 'blur(18px) saturate(0.4) brightness(0.5)',
      },
    },
  ];

  const currentVariant = transitionVariants[currentHeroIndex % transitionVariants.length];
  const currentSlide = HERO_SLIDES[currentHeroIndex];
  const isVideoSlide = currentSlide?.type === 'video';
  const isFullPlaySlide = !!currentSlide?.playFull;

  // Auto-rotate — 4s for images, 7s for looped videos, NO auto-advance on "playFull" slides
  // (those advance themselves via the video's onEnded handler)
  useEffect(() => {
    if (isFullPlaySlide) return; // full-play video controls its own advance
    const dwell = isVideoSlide ? 7000 : 4000;
    const t = setTimeout(() => {
      setDirection(1);
      setCurrentHeroIndex((prev) => (prev + 1) % HERO_SLIDES.length);
    }, dwell);
    return () => clearTimeout(t);
  }, [currentHeroIndex, isVideoSlide, isFullPlaySlide]);

  const nextHero = () => {
    setDirection(1);
    setCurrentHeroIndex((prev) => (prev + 1) % HERO_SLIDES.length);
  };

  const prevHero = () => {
    setDirection(-1);
    setCurrentHeroIndex((prev) => (prev - 1 + HERO_SLIDES.length) % HERO_SLIDES.length);
  };

  /* ── Touch swipe ── */
  const touchStartX = React.useRef(0);
  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? nextHero() : prevHero(); }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const [featuredRes, promoRes] = await Promise.all([
          axios.get(`${API}/products?featured=true`),
          axios.get(`${API}/products?promo=true`)
        ]);
        setFeaturedProducts(featuredRes.data.slice(0, 8));
        setPromoProducts(promoRes.data.slice(0, 4));
      } catch (err) {
        console.error('Error fetching products:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  return (
    <div className="min-h-screen">
      {/* Promo Marquee */}
      <div className="border-y-2 border-[#0A0A0A] bg-[#FAD4D4] py-3">
        <Marquee speed={50} gradient={false}>
          <span className="text-sm uppercase tracking-[0.2em] font-semibold mx-8">
            FREE SHIPPING OVER $100 • NEW ARRIVALS WEEKLY • USE CODE DOEWIZ20 FOR 20% OFF • FREE RETURNS WITHIN 30 DAYS •
          </span>
          <span className="text-sm uppercase tracking-[0.2em] font-semibold mx-8">
            FREE SHIPPING OVER $100 • NEW ARRIVALS WEEKLY • USE CODE DOEWIZ20 FOR 20% OFF • FREE RETURNS WITHIN 30 DAYS •
          </span>
        </Marquee>
      </div>

      {/* Hero Section */}
      <section className="hero-section relative bg-[#FDFBF7] overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Text Content */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="order-2 lg:order-1"
            >
              <span className="text-sm uppercase tracking-[0.2em] font-semibold text-[#525252]">
                A Smart Way To Get Money™
              </span>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-none mt-4 mb-6" style={{ fontFamily: "'Outfit', sans-serif" }}>
                DOE WIZ<br />
                <span className="bg-[#FAD4D4] px-2">APPAREL</span>
              </h1>
              <p className="text-lg text-[#525252] mb-8 max-w-md">
                Premium streetwear for the whole family. Signature tracksuits, hoodies, caps, and more. Dress like a boss.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/products">
                  <Button
                    data-testid="hero-shop-btn"
                    className="bg-[#0A0A0A] text-white border-2 border-[#0A0A0A] rounded-none h-14 px-8 font-semibold text-base hover:translate-y-[-2px] hover:shadow-[4px_4px_0px_rgba(0,0,0,0.3)] transition-all"
                  >
                    Shop Now
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
                <Link to="/products?promo=true">
                  <Button
                    variant="outline"
                    data-testid="hero-sale-btn"
                    className="border-2 border-[#0A0A0A] rounded-none h-14 px-8 font-semibold text-base hover:bg-[#FAD4D4] hover:shadow-[4px_4px_0px_#0A0A0A] transition-all"
                  >
                    View Sale Items
                  </Button>
                </Link>
              </div>
            </motion.div>

            {/* Hero Image with Rotation */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="order-1 lg:order-2"
            >
              <div className="relative">
                <div className="aspect-[4/5] border-2 border-[#0A0A0A] overflow-hidden hard-shadow-lg relative"
                  onTouchStart={handleTouchStart}
                  onTouchEnd={handleTouchEnd}
                >
                  <AnimatePresence mode="wait">
                    {isVideoSlide ? (
                      <motion.video
                        key={currentHeroIndex}
                        src={currentSlide.src}
                        poster="https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/42ga4cu4_1000155929.jpg"
                        autoPlay
                        muted
                        loop={currentSlide.loop !== false}
                        playsInline
                        preload="auto"
                        onLoadedMetadata={(e) => { e.currentTarget.play().catch(() => {}); }}
                        onCanPlay={(e) => { e.currentTarget.play().catch(() => {}); }}
                        onEnded={() => {
                          // When a full-play video finishes, roll the carousel back to the top
                          if (isFullPlaySlide) {
                            setDirection(1);
                            setCurrentHeroIndex(0);
                          }
                        }}
                        className="w-full h-full object-cover object-center bg-[#0A0A0A]"
                        initial={currentVariant.initial}
                        animate={currentVariant.animate}
                        exit={currentVariant.exit}
                        transition={{ duration: 0.55, ease: [0.85, 0, 0.15, 1] }}
                        style={{ transformStyle: 'preserve-3d', backfaceVisibility: 'hidden' }}
                        data-testid="hero-video"
                      />
                    ) : (
                      <motion.img
                        key={currentHeroIndex}
                        src={optHero(currentSlide.src)}
                        alt="Doe Wiz Apparel"
                        className="w-full h-full object-cover object-top"
                        initial={currentVariant.initial}
                        animate={currentVariant.animate}
                        exit={currentVariant.exit}
                        transition={{ duration: 0.55, ease: [0.85, 0, 0.15, 1] }}
                        style={{ transformStyle: 'preserve-3d', backfaceVisibility: 'hidden' }}
                      />
                    )}
                  </AnimatePresence>

                  {/* FULL-FRAME FLASH — fires every slide, gives a cinematic strobe */}
                  <motion.div
                    key={`flash-${currentHeroIndex}`}
                    className="pointer-events-none absolute inset-0 bg-white"
                    initial={{ opacity: 0.85 }}
                    animate={{ opacity: 0 }}
                    transition={{ duration: 0.28, ease: 'easeOut' }}
                  />

                  {/* Heavier scanline overlay that sweeps down */}
                  <motion.div
                    key={`scan-${currentHeroIndex}`}
                    className="pointer-events-none absolute inset-0 mix-blend-overlay"
                    style={{
                      backgroundImage:
                        'repeating-linear-gradient(180deg, rgba(255,255,255,0.12) 0 1px, transparent 1px 4px)',
                    }}
                    initial={{ opacity: 1, backgroundPositionY: 0 }}
                    animate={{ opacity: 0, backgroundPositionY: 240 }}
                    transition={{ duration: 0.65, ease: 'easeOut' }}
                  />

                  {/* Dual glitch bars — magenta + cyan slashing across */}
                  <motion.div
                    key={`glitch1-${currentHeroIndex}`}
                    className="pointer-events-none absolute left-0 right-0 h-[10px] mix-blend-screen"
                    style={{ background: 'linear-gradient(90deg,#FF2E5C 0%,transparent 60%,transparent 100%)' }}
                    initial={{ top: '15%', scaleX: 0, opacity: 1 }}
                    animate={{ top: '85%', scaleX: 1, opacity: 0 }}
                    transition={{ duration: 0.5, ease: 'easeOut' }}
                  />
                  <motion.div
                    key={`glitch2-${currentHeroIndex}`}
                    className="pointer-events-none absolute left-0 right-0 h-[6px] mix-blend-screen"
                    style={{ background: 'linear-gradient(90deg,transparent 0%,transparent 40%,#00E5FF 100%)' }}
                    initial={{ top: '60%', scaleX: 0, opacity: 1 }}
                    animate={{ top: '25%', scaleX: 1, opacity: 0 }}
                    transition={{ duration: 0.55, ease: 'easeOut', delay: 0.08 }}
                  />
                </div>
                {/* Decorative Element */}
                <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#D4E2FA] border-2 border-[#0A0A0A] -z-10"></div>
                <div className="absolute -top-4 -right-4 w-32 h-32 bg-[#FDF0D5] border-2 border-[#0A0A0A] -z-10"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Bar */}
      <section className="border-y-2 border-[#0A0A0A] bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x-2 divide-[#0A0A0A]">
            {[
              { icon: Truck, title: 'Free Shipping', desc: 'On orders over $100' },
              { icon: RefreshCw, title: 'Easy Returns', desc: '30 day return policy' },
              { icon: Shield, title: 'Secure Payment', desc: '100% secure checkout' },
              { icon: Star, title: 'Quality Guarantee', desc: 'Premium materials' },
            ].map((feature, idx) => (
              <div key={idx} className="py-6 px-4 text-center">
                <feature.icon className="w-6 h-6 mx-auto mb-2" />
                <h4 className="font-semibold text-sm">{feature.title}</h4>
                <p className="text-xs text-[#525252] mt-1">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Categories Bento Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <span className="text-sm uppercase tracking-[0.2em] font-semibold text-[#525252]">
            Shop By Category
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight mt-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            FIND YOUR FIT
          </h2>
        </div>

        <div className="grid grid-cols-12 gap-4">
          {/* Men - Large (leads the grid) */}
          <Link
            to="/products?category=men"
            data-testid="category-men"
            className="col-span-12 md:col-span-8 relative aspect-[4/5] md:aspect-auto md:h-[400px] border-2 border-[#0A0A0A] overflow-hidden group card-brutalist"
          >
            <img
              src={optCard(categories[1].image)}
              alt="Men"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="bg-[#D4E2FA] px-4 py-2 text-2xl md:text-3xl font-black tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                MEN
              </span>
            </div>
          </Link>

          {/* Women - Medium */}
          <Link
            to="/products?category=women"
            data-testid="category-women"
            className="col-span-12 md:col-span-4 relative aspect-[4/5] md:h-[400px] border-2 border-[#0A0A0A] overflow-hidden group card-brutalist"
          >
            <img
              src={optCard(categories[0].image)}
              alt="Women"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="bg-[#FAD4D4] px-4 py-2 text-2xl font-black tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                WOMEN
              </span>
            </div>
          </Link>

          {/* Kids - Medium */}
          <Link
            to="/products?category=boys"
            data-testid="category-kids"
            className="col-span-12 sm:col-span-6 relative aspect-[4/3] border-2 border-[#0A0A0A] overflow-hidden group card-brutalist"
          >
            <img
              src={optCard(categories[2].image)}
              alt="Kids"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="bg-[#FDF0D5] px-4 py-2 text-2xl font-black tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                KIDS
              </span>
            </div>
          </Link>

          {/* Babies - COMING SOON (fills the empty slot next to Kids on desktop/tablet) */}
          <Link
            to="/products?category=babies"
            data-testid="category-babies"
            className="col-span-12 sm:col-span-6 relative aspect-[4/3] border-2 border-[#0A0A0A] overflow-hidden group card-brutalist"
          >
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/uploads/babies_coming_soon.png`}
              alt="Doe Wiz Babies — Coming Soon"
              className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            {/* Coming-soon corner badge */}
            <div className="absolute top-4 right-4 bg-[#FAD4D4] border-2 border-[#0A0A0A] px-3 py-1 text-[10px] font-black tracking-widest">
              COMING SOON
            </div>
            <div className="absolute bottom-6 left-6">
              <span className="bg-[#F5E6D3] px-4 py-2 text-2xl font-black tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                BABIES
              </span>
            </div>
          </Link>

          {/* Hats - Small */}
          <Link
            to="/products?category=hats"
            data-testid="category-hats"
            className="col-span-12 sm:col-span-12 relative aspect-[4/3] border-2 border-[#0A0A0A] overflow-hidden group card-brutalist"
          >
            <img
              src={optCard(categories[3].image)}
              alt="Hats"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="bg-[#D5FDD8] px-4 py-2 text-2xl font-black tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                HATS
              </span>
            </div>
          </Link>

          {/* Accessories - SUSPENDED 2026-05 per user directive. Coming back later. */}
          {/* <Link
            to="/products?category=accessories"
            data-testid="category-accessories"
            className="col-span-12 sm:col-span-6 relative aspect-[4/3] border-2 border-[#0A0A0A] overflow-hidden group card-brutalist"
          >
            <img
              src={optCard(categories[4].image)}
              alt="Accessories"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="bg-[#F0D5FD] px-4 py-2 text-2xl font-black tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                ACCESSORIES
              </span>
            </div>
          </Link> */}

          {/* Footwear - Full Width */}
          <Link
            to="/footwear"
            data-testid="category-footwear"
            className="col-span-12 relative aspect-[16/7] border-2 border-[#0A0A0A] overflow-hidden group card-brutalist"
          >
            <img
              src={optHero("https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/y9cvy4ii_TB0A5NGSEYJ.png.png.webp")}
              alt="Footwear — BEAMS x Timberland"
              className="w-full h-full object-contain object-center bg-[#FDF0D5] transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="bg-[#FDF0D5] px-4 py-2 text-2xl md:text-3xl font-black tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                FOOTWEAR
              </span>
            </div>
          </Link>
        </div>
      </section>

      {/* Featured Products */}
      <section className="bg-white border-y-2 border-[#0A0A0A] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
            <div>
              <span className="text-sm uppercase tracking-[0.2em] font-semibold text-[#525252]">
                Curated Selection
              </span>
              <h2 className="text-4xl sm:text-5xl font-bold tracking-tight mt-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                FEATURED PICKS
              </h2>
            </div>
            <Link
              to="/products?featured=true"
              data-testid="view-all-featured"
              className="mt-4 md:mt-0 text-sm font-semibold uppercase tracking-wider flex items-center hover:underline"
            >
              View All <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </div>

          {loading ? (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="aspect-[3/4] border-2 border-[#0A0A0A] skeleton"></div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4">
              {featuredProducts.map((product, idx) => (
                <motion.div
                  key={product.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: idx * 0.1 }}
                >
                  <ProductCard product={product} />
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Sale Banner */}
      <section className="bg-[#0A0A0A] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <span className="text-sm uppercase tracking-[0.2em] font-semibold text-[#FAD4D4]">
                Limited Time Offer
              </span>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight mt-4 mb-6" style={{ fontFamily: "'Outfit', sans-serif" }}>
                UP TO 25%<br />OFF SALE
              </h2>
              <p className="text-lg text-white/70 mb-8 max-w-md">
                Don't miss out on our biggest sale of the season. Shop now and save on your favorite styles.
              </p>
              <Link to="/products?promo=true">
                <Button
                  data-testid="sale-shop-btn"
                  className="bg-white text-[#0A0A0A] border-2 border-white rounded-none h-14 px-8 font-semibold text-base hover:bg-[#FAD4D4] hover:border-[#FAD4D4] hover:translate-y-[-2px] transition-all"
                >
                  Shop Sale
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-2 sm:gap-4">
              {promoProducts.slice(0, 4).map((product) => (
                <Link
                  key={product.id}
                  to={`/product/${product.id}`}
                  className="aspect-square border-2 border-white/20 overflow-hidden group"
                >
                  <img
                    src={optCard(product.images?.[0]) || '/placeholder.jpg'}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* WiZ-PiS Lingerie Coming Soon */}
      <section className="py-16 bg-[#0A0A0A]" data-testid="wizpis-coming-soon">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-0 border-2 border-[#333] overflow-hidden">
            <div className="relative aspect-[3/4] md:aspect-auto">
              <img
                src={optHero("https://customer-assets.emergentagent.com/job_9b5e85e7-cfb4-4ed2-9bc1-5a96c527aff2/artifacts/zkktkto6_8802-Black-Front_567x850.jpg.webp")}
                alt="WiZ-PiS Lingerie"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col items-center justify-center p-8 md:p-12 text-center bg-[#0A0A0A]">
              <span className="text-xs uppercase tracking-[0.3em] font-semibold text-[#FAD4D4] mb-4">
                New Brand
              </span>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                WiZ-PiS
              </h2>
              <p className="text-white/60 text-sm md:text-base mb-6 max-w-sm">
                Luxury lingerie by Doe Wiz. Bold. Confident. Unapologetic.
              </p>
              <div className="inline-block border-2 border-[#FAD4D4] px-6 py-3">
                <span className="text-[#FAD4D4] font-bold text-sm uppercase tracking-[0.2em]">
                  Coming Soon
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram / Social Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-sm uppercase tracking-[0.2em] font-semibold text-[#525252]">
            Follow Us
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight mt-2 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            @DOEWIZAPPAREL
          </h2>
          <p className="text-[#525252] mb-8">Tag us in your photos and get featured!</p>
          <a
            href="https://x.com/DoeWizApparel"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="follow-twitter"
            className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white border-2 border-[#0A0A0A] px-6 py-3 font-semibold hover:translate-y-[-2px] hover:shadow-[4px_4px_0px_rgba(0,0,0,0.3)] transition-all"
          >
            Follow on X
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>
    </div>
  );
}
